import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
// import WSDataGridCollapsable, {
//   IColumnsCollapsable
// } from "../../Components/DataGrid/WSDataGridCollapsable";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { HeaderList } from "../../Components/Header/HeaderList";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";

export const ServiceProductMappingList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit, add, view } = getPermissions(
    MasterPages.AddOnService,
    IRoleMain.Masters
  );
  const [serviceProductList, setServiceProductList] = useState<any>([]);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const [reload, setReload] = useState(false);
  const [totalCount, setTotalCount] = useState<any>();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  useEffect(() => {
    async function getMappedServiceProducts() {
      const response: any = await callAPI("Mapping/all", Method.GET);

      if (response) {
        setServiceProductList(response || []);
        setTotalCount(response?.length);
      }
    }
    getMappedServiceProducts();
  }, []);
  useEffect(() => {
    async function getMappedServiceProducts() {
      const response: any = await callAPI("Mapping/all", Method.GET);
      // const serveceProductArr: Array<any> = [];
      if (response) {
        setServiceProductList(response || []);
        setTotalCount(response?.length);
      }
    }
    getMappedServiceProducts();
    setReload(false);
  }, [reload]);

  // const delinkService = async (row: any) => {
  //   try {
  //     const response = await callAPI(
  //       `laundry-service-products/${row?.productId}/unlink/${row?.id}`,
  //       Method.DELETE
  //     );
  //     if (response && response?.success) {
  //       showMessage(
  //         response?.message || "Service delink done successfully",
  //         "success"
  //       );
  //       setReload(true);
  //     }
  //   } catch (e) {
  //     showMessage("Something went wrong", "error");
  //   }
  // };

  const columns: IColumns[] = [
    {
      header: "Product",
      fieldName: "productName",
      type: "default"
    },
    {
      header: "Type",
      fieldName: "productType",

      type: "default"
    },

    {
      header: "Service",
      fieldName: "serviceName",
      type: "default"
    },

    {
      header: "Price",
      fieldName: "price",
      type: "default"
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];
  const handleAction = (action: string, row: any) => {
    if (action === "Delete") {
      setSelectedId(row?.id);
      setPopupOpen(true);
    }else if(action === "Edit"){
      navigate(`/service-product-map/${row?.id}`)
    }
  };
  const handleClick = () => {
    navigate("/service-product-map");
  };
  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("serviceGrid"));
    showMessage("Service removed successfully!", "success");
  };
  return (
    <>
      <HeaderList
        title="Service to Product Mapping"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {/* {view ?  <Grid container spacing={2}>
                <Grid item xs={12}>
                    {serviceProductList && <WSDataGridCollapsable buttonStyle="Normal"
                     addButton={add ? { label: 'New', color: 'secondary' } : undefined}
                        onAddButtonClick={handleClick} id="serviceGrid" columns={columns} rows={serviceProductList} title="Mapping" />}
                </Grid>
            </Grid>:<PermissionDenied/>} */}

      {view ? (
        <Grid item xs={12}>
          <WSDataGrid
            id="serviceGrid"
            title="Services"
            columns={columns}
            headerType="HaderTopCornered"
            //  source={source}
            data={serviceProductList}
            // exportCsv={exports}
            addButton={add ? { label: "", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            //transFormData={transFormData}
          />
        </Grid>
      ) : (
        <PermissionDenied />
      )}
      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"Brand/delete"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this item?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
        />
      )}
    </>
  );
});
